export const TRAINING_REPORT_LIST_STATE =
    "app.growers.grower.manageSafety.trainingReports";
export const TRAINING_REPORT_STATE = `${TRAINING_REPORT_LIST_STATE}.report`;

export function newTrainingReportDefinition() {
    return {
        version: 1,
        employees: {
            include: [
                {
                    type: "growerMembershipActive",
                    growerMembershipActive: true,
                },
            ],
            exclude: [],
        },
        training: { courses: [], topics: [] },
        criteria: { period: "rolling", amount: 12, unit: "months" },
        match: { condition: "everyone", quantifier: "any" },
        display: { view: "matrix" },
    };
}

export function copyReportDefinition(definition) {
    return JSON.parse(JSON.stringify(definition));
}

export function selectedTrainingTopicSids(training, catalog) {
    const courseTopics = catalog.courses
        .filter((course) => training.courses.includes(course.sid))
        .flatMap((course) => course.topics);
    return [...new Set([...courseTopics, ...training.topics])];
}

export function prepareTrainingReport(report) {
    const topicBySid = Object.fromEntries(
        report.topics.map((topic) => [topic.sid, topic]),
    );
    const groups = report.groups.map((group, groupIndex) => ({
        ...group,
        columns: group.topics.map((sid, topicIndex) => ({
            ...topicBySid[sid],
            key: `${groupIndex}:${topicIndex}`,
            groupIndex,
        })),
    }));
    const columns = groups.flatMap((group) => group.columns);
    return {
        ...report,
        groups,
        columns,
        topicBySid,
        results: report.results.map((row) => {
            if (!row.cells) {
                return row;
            }
            const cellsByTopic = Object.fromEntries(
                row.cells.map((cell) => [cell.topic, cell]),
            );
            return {
                ...row,
                cellsByTopic,
                displayCells: columns.map((column) => ({
                    ...cellsByTopic[column.sid],
                    columnKey: column.key,
                    topicName: column.name,
                })),
            };
        }),
    };
}

export function trainingReportErrors(data) {
    const messages = [];
    function visit(value, path) {
        if (typeof value === "string") {
            messages.push(path ? `${path}: ${value}` : value);
        } else if (Array.isArray(value)) {
            value.forEach((item) => visit(item, path));
        } else if (value && typeof value === "object") {
            Object.entries(value).forEach(([key, item]) => {
                visit(
                    item,
                    key === "detail" || key === "non_field_errors"
                        ? path
                        : [path, key].filter(Boolean).join("."),
                );
            });
        }
    }
    visit(data, "");
    return messages;
}
